const findNextEnabledIndex = (direction, ineligibleDays, isDisabled, numbersLength, startIndex) => {
    let currentIndex = startIndex;
    const step = direction === 'right' ? 1 : -1;
    const isDayDisabled = (num) => isDisabled(num, ineligibleDays);
    while (currentIndex >= 0 && currentIndex < numbersLength) {
        if (!isDayDisabled(currentIndex)) {
            return currentIndex;
        }
        currentIndex += step;
    }
    return startIndex - step;
};
export default findNextEnabledIndex;
